export type LatLng = {
  latitude?: number | '';
  longitude?: number | '';
};

export type Schedule = {
  openDay: string;
  openTime: string;
  closeTime: string;
};

export type LocationFields = {
  city: string;
  epicdeptid: string;
  epicproviderid: string | null;
  id: string;
  latitude: string;
  locationid: string;
  locationType: Array<string>;
  longitude: string;
  publishToLocal: boolean;
  phone: string;
  state: string;
  street1: string;
  street2: string;
  zip: string;
  title: string;
  image: string;
  link: string;
};

export type LocationResultType = {
  distance?: number;
  location: LocationFields;
};

export type ProviderFields = {
  acceptingnewpatients: boolean;
  availability: string | Array<string>;
  clinicalfocusareas: Array<string>;
  degrees: Array<string>;
  epicid: string | null;
  externalid: string;
  npi: string;
  firstname: string;
  fullname: string;
  gender: 'Male' | 'Female';
  id: string;
  lastname: string;
  locations: [];
  onlinescheduling: boolean;
  specialty: Array<string>;
  specialties: Array<string>;
  title: string;
  image: string;
  link: string;
};

export type ProviderResultType = {
  distance: number;
  provider: ProviderFields;
};
